import { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { DateTime } from 'luxon'
import useLocalStorage from '@hooks/useLocalStorage'

type Props = {
  profile?: any
}

export function GroveNFeAlert({ profile }: Props) {
  const [showModal, setShowModal] = useState(false)
  const [alreadyShown, setAlreadyShown] = useLocalStorage<boolean>('groveNFeAlertShown', false)

  useEffect(() => {
    if (!profile) return
    const created =
      profile?.options?.integrations?.grovenfe?.created_at 
    if (!created) return
    const createdAt = DateTime.fromISO(created)
    if (!createdAt.isValid) return
    const days = Math.abs(Math.round(DateTime.now().diff(createdAt, 'days').days))
    console.log('days since GroveNFe creation:', days)
    if (days >= 30) {
      setShowModal(true)
    }
  }, [profile])

  const handleClose = () => {
    setShowModal(false)
    setAlreadyShown(true)
  }

  return (
    <Modal 
        show={showModal && !alreadyShown} 
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-bottom-0 pb-2">
          <Modal.Title className="w-100 text-center">
            <div className="d-flex align-items-center justify-content-center">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="32" 
                height="32" 
                fill="#ff9800" 
                className="bi bi-exclamation-triangle-fill me-2" 
                viewBox="0 0 16 16"
              >
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
              </svg>
              <span style={{ color: '#012970', fontSize: '22px', fontWeight: '600' }}>
                Aviso Importante - GroveNFCe
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="px-4 py-4">
          <div className="text-center mb-3">
            <h5 style={{ color: '#012970', fontWeight: '700', fontSize: '20px', marginBottom: '20px' }}>
              Parabéns! Seu período de teste gratuito foi concluído com sucesso. 😊
            </h5>
            <div style={{ 
              backgroundColor: '#f8f9fa', 
              padding: '20px', 
              borderRadius: '10px',
              border: '2px solid #e9ecef'
            }}>
              <p style={{ 
                fontSize: '16px', 
                color: '#495057', 
                marginBottom: '15px',
                lineHeight: '1.6'
              }}>
                🚀  A partir da próxima fatura, o serviço de emissão automática de notas fiscais seguirá ativo com o valor adicional de <strong style={{ color: '#0477FF' }}>+R$50,00</strong>.
              </p>
            </div>
            <p style={{ 
              fontSize: '14px', 
              color: '#6c757d',
              marginTop: '20px',
              lineHeight: '1.5'
            }}>
              Você continua contando com toda a praticidade e segurança da automação de NFC-e, sem interrupções
            </p>
          </div>
        </Modal.Body>
        
        <Modal.Footer className="border-top-0 justify-content-center pt-0 pb-4">
          <Button 
            variant="primary" 
            onClick={handleClose}
            style={{
              backgroundColor: '#0477FF',
              borderColor: '#0477FF',
              padding: '10px 40px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '6px'
            }}
          >
            Entendi
          </Button>
        </Modal.Footer>
      </Modal>
  )
}
